export const ADD_TO_WALLET_URL = 'https://pkpass.acteol.com/462/v1/passes/create/Pwd';
export const BOOK_A_TABLE_MODAL_CTA =
  '&utm_source=Z_popup&utm_medium=zillionaires&utm_campaign=30_z_popup&utm_content=pop_book';
export const AZQR_URL = 'https://azqr.co.uk/';
